<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row">
      <div class="col-12 text-left">
        <button v-if="id !== 'new'" @click="del" type="button" class="btn btn-danger">
          حذف کدتخفیف
          <i class="fas fa-trash"/>
        </button>
        <button type="submit" class="btn btn-success mr-2">
          <span v-if="id !== 'new'">
            بروررسانی کدتخفیف
          <i class="far fa-save"/>
          </span>
          <span v-else>
            ذخیره کدتخفیف جدید
                <i class="fas fa-plus"/>
          </span>
        </button>

        <hr>
      </div>
      <div v-if="id === 'new'  || (id !== 'new' && Object.keys(item).length )" class="col-12">
        <div class="row">
          <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
            <StatsCard>
              <div class="icon-big text-center icon-info" slot="header">
                <i class="fas fa-unlock-alt"/>
              </div>
              <div class="text-center" slot="content">
                <p>تاریخ ایجاد</p>
                {{$dateTimeFormat(item.created_at)}}
              </div>
            </StatsCard>
          </div>
          <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
            <StatsCard>
              <div class="icon-big text-center icon-info" slot="header">
                <i class="fas fa-check"/>
              </div>
              <div class="text-center" slot="content">
                <p>تعداد باقی مانده از این کد</p>
                {{$priceMask(item.remain)}} عدد
              </div>
            </StatsCard>
          </div>
          <div class="col-12">
            <card class="card" title="اطلاعات پایه">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="title">عنوان</label>
                      <input id="title" type="text" class="form-control" placeholder="عنوان" v-model="item.title">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="code">کدتخفیف</label>
                      <input id="code" type="text" class="form-control" placeholder="کدتخفیف" v-model="item.code">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="expires_at">تاریخ انقضا</label>
                      <appDatePicker id="expires_at" placeholder="تاریخ انقضا" v-model="item.expires_at"/>
                    </div>
                  </div>

                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="discount">درصد تخفیف</label>
                      <input id="discount" type="number" class="form-control" placeholder="درصد تخفیف"
                             v-model.number="item.discount">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="max_discount_amount">حداکثر میزان تخفیف(ریال)</label>
                      <input id="max_discount_amount" type="text" class="form-control" placeholder="ریال"
                             :value="$priceMask(item.max_discount_amount)"
                             @input="item.max_discount_amount = $normalNum($event.target.value)">

                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="min_cart_amount">حداقل مبلغ سفارش برای اعمال این کد تخفیف(ریال)</label>
                      <input id="min_cart_amount" type="text" class="form-control" placeholder="ریال"
                             :value="$priceMask(item.min_cart_amount)"
                             @input="item.min_cart_amount = $normalNum($event.target.value)">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="count">حداکثر تعداد حساب‌کاربری برای استفاده از این کد</label>
                      <input id="count" type="number" class="form-control" placeholder="درصد تخفیف"
                             v-model.number="item.count">
                    </div>
                  </div>


                  <div class="col-12 col-xl-4 mb-3">
                    <div class="form-group text-right">
                      <label for="ref_type" class="text-right mb-1">اعمال این کدتخفیف برای</label>
                      <fv-select id="ref_type" class="fv-form-control" v-model="item.ref_type"
                                 :options="[
                         {text: 'فقط یک اشتراک',value:'plan'},
                         {text: 'همه اشتراک‌ها',value:'discount'},
                         ]"/>
                    </div>
                  </div>
                  <div class="col-12 col-xl-4 mb-3" v-if="item.ref_type === 'plan'">
                    <div class="form-group text-right">

                      <label for="ref_type" class="text-right mb-1">انتخاب اشتراک</label>
                                          <appPlanSelector justId v-model="item.ref_id"/>
                    </div>
                  </div>

                  <div class="col-12 col-xl-4 mb-3">
                    <div class="form-group text-right">
                      <label for="first_order">اعمال این کد تنها برای اولین سفارش کاربر</label>
                      <fv-switch id="first_order" class="form-control d-block" placeholder="تنها برای سفارش اول"
                                 v-model="item.first_order"/>
                    </div>
                  </div>


                  <!--                  <div class="col-12 col-lg-4 mb-3">-->
                  <!--                    <div class="form-group text-right">-->
                  <!--                      <label for="discount_price">قیمت</label>-->
                  <!--                      <input id="discount_price" type="number" class="form-control" placeholder="قیمت"-->
                  <!--                             v-model.number="item.order">-->
                  <!--                    </div>-->
                  <!--                  </div>-->

                  <div class="clearfix"/>
                </div>
              </div>
            </card>
          </div>
        </div>


      </div>
    </div>
  </form>
</template>
<script>
	import Modela from 'modela'
	import {mapActions} from "vuex"
	import voucherModel from "../../models/vouchers"
	import {StatsCard} from "@/components/index";
  import appPlanSelector from "../../components/appPlanSelector";
  import appDatePicker from "../../components/appDatePicker";
	export default {
		name: 'voucher_edit',
		components: {StatsCard, appPlanSelector, appDatePicker},
		data() {
			const {params} = this.$route
			const {id} = params
			return {
				...mapActions('main', [
					'crud'
				]),
				id,
				item: {},
			}
		},
		computed: {},
		methods: {
			async getData() {
				try {
					this.$store.commit('main/SET', {key: 'loading', value: true})
					const plan = await this.crud({
						action: 'get',
						section: 'vouchers',
						id: this.id,
						showError: true
					})

					const result = plan.data
					let item = new Modela(voucherModel)
					item = item.$clean()
					item = item.$set(result)
					this.item = item.$clean().$export()

				} catch (e) {
					console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async post() {
				try {
					this.$store.commit('main/SET', {key: 'loading', value: true})
					const newVoucher = await this.crud({
						action: 'post',
						section: 'vouchers',
						data: this.item,
						showError: true
					})
					await this.$successAlert()
					this.$router.go(-1)
					// await this.$router.push({name: 'plans'})
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}

			},
			async put() {
				try {
					this.$store.commit('main/SET', {key: 'loading', value: true})
					const updateVoucher = await this.crud({
						action: 'put',
						section: 'vouchers',
						id: this.id,
						data: this.item,
						showError: true
					})
					this.$successAlert()
					this.$router.go(-1)
					// await this.$router.push({name: 'plans'})
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}

			},
			async del() {
				if (!await this.$confirmAlert())
					return false
				try {
					this.$store.commit('main/SET', {key: 'loading', value: true})
					const deleted = await this.crud({
						action: 'delete',
						section: 'vouchers',
						id: this.id,
						showError: true
					})
					await this.$successAlert()
					// await this.$router.push({name: 'plans'})
					this.$router.go(-1)
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async submit() {
				if (this.id !== 'new')
					this.put()
				else
					this.post()
			},
		},
		async created() {
			if (this.id !== 'new')
				await this.getData()
			else {
				let item = new Modela(voucherModel)
				this.item = item.$clean().$export()
			}
		}
	};
</script>
<style>
</style>
